<template>
  <div>
    <div v-wechat-title='"迷途春节h5活动"'></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="title"></div>
      <div class="main"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp } from '@/utils/utils';
export default {
  components: {},
  data () {
    return {
      
    };
  },
  created () {},
  mounted () {
    this.$nextTick(() => {
      this.monitoringEquipment();
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `https://h5.qingcigame.com/mitu/year/enter${getTimeStamp()}`
      }
    }
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/mitu/year/pc/index.vue